import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import FilesTypesListView from "./files_types-list.html";
import FilesTypesEditView from "./files_types-edit.html";


angular.module("files_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('files_types', {
                url: "/files_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('files_types.list', {
                url: "/list",
                controller: "FilesTypesListCtrl",
                template: FilesTypesListView,
                requiredPermission: ["EVENTS_TYPES_READ"]
            })             
            .state('files_types.edit', {
                url: "/edit/:id",
                controller: "FilesTypesEditCtrl",
                template: FilesTypesEditView,
                requiredPermission: ["EVENTS_TYPES_READ"]
            })
    }])
;